module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps1"
  }, [_vm._v("T THE")])]), _vm._v(" beginning of this book I wish to express my deep appreciation to all who contributed to its publication. I thank the Calvin Alumni Association for funding my travel to South Africa in 1993 for five months of research at three major Reformed universities. I also wish to thank the staff of the libraries in Stellenbosch, Bloemfontein, and Potchefstroom for their courteous service.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am also grateful to the Calvin Seminary Heritage Fund for underwriting further research in Europe in 1997, especially at Tyndale House, Cambridge, England. I thank the staff of Tyndale House and its supporters for providing an ideal atmosphere for conducting biblical research.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In North America, the splendid library of Calvin College and Seminary also served me very well. I am grateful to the Calvin library staff for its helpful service, for tracking down articles and books, and for ordering some by way of inter-library loan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I also want to express my gratitude to my student assistants: Cindy Holtrop, particularly for typing the original, lengthy bibliography in proper form, and David Vroege, particularly for proofreading the entire manuscript and working on the subject and text indexes. I further thank the staff at Eerdmans for their capable work.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("I especially wish to thank a few experts in Old Testament interpretation and theology who took time out of their busy schedules to proofread part or all of the manuscript. Richard A. Muller, Professor of Historical Theology at Calvin Seminary, checked the historical chapters, while Ronald J. Feenstra, Professor of Systematic and Philosophical Theology, and John H. Stek, Professor (Emeritus) of Old Testament, at the Seminary, checked and commented on the entire manuscript. Family members were also involved in this project: my sister, Janice Greidanus Baker, teacher of French in Sarnia, Ontario, read the whole manuscript for readability, and my brother-in-law, George Vandervelde, Senior Member in Systematic ")]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("Theology at the Institute for Christian Studies in Toronto, offered numerous worthwhile suggestions.")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A special word of thanks is due to my faithful wife and best friend, Marie. She not only encouraged me in this major project but accompanied me on many trips to libraries on various continents, took notes, typed bibliographical entries, searched the stacks for books and articles, copied relevant pages, filed and refiled books and articles in my study, and never complained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Above all, I am thankful to the Lord for providing so much encouragement for this project through relatives and friends, fellow church members, and scholars in different countries. I also thank the Lord for providing me with good health during the years of research, for sudden flashes of insight for solving perplexing problems, and for constant joy in working on this important project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Board of Trustees of Calvin Theological Seminary granted me not only a sabbatical leave but also a publication leave to finish this book. I thank the board members for their confidence in me. And I thank my colleagues and students for their helpful comments. I dedicate this book to all involved in the mission of Calvin Seminary.")]), _vm._v(" "), _c('p', {
    staticClass: "para-right2"
  }, [_c('em', [_vm._v("To the Students, Staff, and Supporters of Calvin Theological Seminary")])]), _vm._v(" "), _c('p', {
    staticClass: "para-rightb"
  }, [_c('em', [_vm._v("Grand Rapids, Michigan")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c7283e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Acknowledgments.vue
// module id = 72
// module chunks = 0